<template>
	<component :style="allowScrollContainer ? 'height: calc(100dvh - 5.9rem); background-color: #f5f5f5;' : 'height: auto'"
		:is="allowScrollContainer ? 'VuePerfectScrollbar' : 'div'">
		<div class="" style="margin-top: 2rem">		
			<div style="font-size: 1.5rem; margin-top: 0.5rem; text-shadow: 2px 2px #ffffff; ">
				<div><strong>Affiliate program</strong></div>			
			</div>
			<div class="mt-5 d-none d-md-flex flex-fill justify-content-center align-items-end">
				<img src="/background/affiliate-program/affiliate-program-background-1.svg" style="width: 22.5rem; max-width: 100%;"
					alt="" />
			</div>	
			<div class="mt-5 d-flex flex-column justify-content-center align-items-center">
				<div class="d-flex"
					style="width: 30.5rem; margin-top: 0.75rem; max-width: 100%; border: 1px solid #ccc; padding: 0.25rem; border-radius: 5px;">
					<el-input id="linkAffiliate" class="d-flex flex-fill" 
						placeholder="Link share ... "
						:value="hostUrl + '/register?affiliateId=' + user.affiliateId"
						style="border: none;">
						<i slot="prefix" class="el-input__icon el-icon-link"></i>
					</el-input>
					<button class="ml-3 px-3 py-1 text-nowrap text-muted" @click="copyLinkAffiliate(`#linkAffiliate`)"
						style="background-color: #F7F8F8; border-radius: 5px; font-size: 90%;">
						<i class="ri-file-copy-line"></i> Copy
					</button>
				</div>
			</div>
		</div>
		<div class="flex-column d-flex align-items-center mt-5" style="font-size: 1rem">
			<div class="div">Share your referral code with your friends to receive </div>
			<div class="div">
				<div><strong style="color: #19B5FE">20%</strong> of the first referall transaction and</div>
				<div><strong style="color: #19B5FE">5%</strong> of the next transactions</div>
			</div>
			<div class="mt-3">Application period:</div>
			<div style="color: #19B5FE">Expire one year from the 1st recharge.</div>
		</div>
		<div class="d-block d-md-none flex-fill justify-content-center align-items-end">
			<img src="/background/affiliate-program/affiliate-program-background-1.svg" style="width: 22.5rem; max-width: 100%;"
				alt="" />
		</div>
	</component>
</template>

<script>
// Lib
import { Notification } from "element-ui";
import { mapState } from "vuex";

// Constant
import { HOST_URL } from "@/constant/routeApi";

export default {
	props: {
		allowScrollContainer: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			hostUrl: HOST_URL.CLIENT_URL,
		};
	},

	computed: {
		...mapState({
			user: (state) => state.auth.user,
		}),
	},

	methods: {
		copyLinkAffiliate(inputId) {
			const el = document.querySelector(inputId);
			el.select();
			el.setSelectionRange(0, 99999);
			$(inputId).show();
			el.focus();
			document.execCommand("copy");
			el.blur();
			Notification.success({
				title: "Copied",
				duration: 1500,
				showClose: false,
				message: `The address has been copied`,
			});
		},
	},
};
</script>

<style>
#linkAffiliate {
	border:  none !important;
}
</style>